import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/tos',
      name: 'tos',
      component: () => import(/* webpackChunkName: "tos" */ './views/TermsOfServices.vue')
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: () => import(/* webpackChunkName: "privacy-policy" */ './views/PrivacyPolicy.vue')
    },
    {
      path: '/account',
      name: 'account',
      component: () => import(/* webpackChunkName: "account" */ './views/Account.vue')
    },
    {
      path: '/latest',
      name: 'latest',
      component: () => import(/* webpackChunkName: "latest" */ './views/Latest.vue')
    },
    {
      path: '/edmc-plugin',
      name: 'edmc-plugin',
      component: () => import(/* webpackChunkName: "edmc-plugin" */ './views/EDMCPlugin.vue')
    },
    {
      path: '/discord-bot',
      name: 'discord-bot',
      component: () => import(/* webpackChunkName: "discord-bot" */ './views/DiscordBot.vue')
    },
    {
      path: '/discord',
      name: 'discord',
      component: () => import(/* webpackChunkName: "discord" */ './views/Discord.vue')
    },
    {
      path: '/donate',
      name: 'donate',
      component: () => import(/* webpackChunkName: "donate" */ './views/Donate.vue')
    },
  ]
})